
















































import { Vue, Component, Watch } from "@/shared/vuepack";
import { useUserStore } from "@/shared/store/user";
import { HSARepResponse, HSARepContactInfo, HSAServiceRepContactInfo } from "@/shared/types";

@Component({ name: "ContactRepCards" })
export default class ContactRepCards extends Vue {
    userStore = useUserStore();
    accountReps = [];
    isServiceContact = true;
    contactAltText = "";
    mapTimezones = {
      "Pacific/Honolulu": "HT",
      "America/Anchorage": "AT",
      "America/Los_Angeles": "PT",
      "America/Phoenix": "MT",
      "America/Denver": "MT",
      "America/Chicago": "CT",
      "America/New_York": "ET",
  };

  get hsaRepResponse (): HSARepResponse {
    return this.userStore.hsaRepResponse;
  }

  @Watch("userStore.hsaRepResponse", {immediate: true, deep: true })
  onSalesforceContactsChanged (hsaRepResponse: HSARepResponse) {
    this.isServiceContact = hsaRepResponse?.useServiceContact;
    this.setContactInfo(hsaRepResponse);
  }

  mounted () {
    this.userStore.getSalesforceContacts();
  }

  setContactInfo (hsaRepResponse: HSARepResponse) {
    this.accountReps = [];
    const data = hsaRepResponse?.employerDetails?.[0];
    if (!data) {
      this.accountReps = [];
      this.contactAltText = "";
      return;
    }

    const aeContact: HSARepContactInfo | undefined = data.aeContact
      ? {
          ...data.aeContact,
          businessHours: this.getBusinessHours(
            data.aeContact.startOfDay,
            data.aeContact.endOfDay,
            data.aeContact.timeZoneSidKey
          ),
        }
      : null;
    const scContact: HSAServiceRepContactInfo | undefined = data.serviceContact;
    const csmContact: HSARepContactInfo | undefined = data.csmContact
      ? {
          ...data.csmContact,
          businessHours: this.getBusinessHours(
            data.csmContact.startOfDay,
            data.csmContact.endOfDay,
            data.csmContact.timeZoneSidKey
          ),
        }
      : null;

    const brContact = {
      ...data.brContact,
      businessHours: this.getBusinessHours(
        data.brContact.startOfDay,
        data.brContact.endOfDay,
        data.brContact.timeZoneSidKey
      ),
    };

    if (data.csmContact) {
      this.checkForServiceContact(data, brContact, csmContact, scContact);
    } else {
      this.getBrContact(data, brContact);
    }

    if (aeContact && aeContact.firstName && aeContact.lastName) {
      this.accountReps.push(aeContact);
      this.contactAltText = "Headshot of account executive";
    }
  }

  getBusinessHours (start: string, end: string, timezone: string) {
    const modifiedStart = Number(start) > 12 ? `${Number(start) - 12}PM` : `${start}AM`;
    const modifiedEnd = Number(end) > 12 ? `${Number(end) - 12}PM` : `${end}AM`;
    return `M-F, ${modifiedStart}-${modifiedEnd} ${this.mapTimezones[timezone]}`;
  }

  getContactRepImage (rep: HSARepContactInfo) {
    return `data:${rep.mediumPhotoFileType};base64, ${rep.mediumPhotoContent}`;
  }

  getBrContact (data: any, brContact: HSARepContactInfo) {
    if (data.brContact.title) {
      brContact.title = data.brContact.title;
    }
    if (data.brContact.hoursConfig === "custom" && data.brContact.customHours) {
      brContact.businessHours = data.brContact.customHours;
    }
    if (data.brContact.hoursConfig === "hide") {
      brContact.businessHours = "";
    }
    this.accountReps.push(brContact);
    this.contactAltText = "Headshot of business representative";
  }

  determineCsmBusinessHours (data: any, csmContact: HSARepContactInfo) {
    if (data.csmContact.hoursConfig === "custom" && data.csmContact.customHours) {
      csmContact.businessHours = data.csmContact.customHours;
    }
    if (data.csmContact.hoursConfig === "hide") {
      csmContact.businessHours = "";
    }
  }

  determineScBusinessHours (data: any, scContact: HSAServiceRepContactInfo) {
     if (data.csmContact.hoursConfig === "custom") {
      if (data.csmContact.businessHours !== null && data.serviceContact?.businessHours !== "") {
        scContact.businessHours = data.csmContact.customHours;
      }
    }
    if (data.csmContact.hoursConfig === "hide") {
      scContact.businessHours = "";
    }
  }

  checkForServiceContact (data: any, brContact: HSARepContactInfo, csmContact?: HSARepContactInfo, scContact?: HSAServiceRepContactInfo) {

    if (
      this.isServiceContact &&
      scContact &&
      (scContact.firstName || scContact.lastName)
    ) {

      scContact.repTypeHoverText = data.serviceContact && data.serviceContact.repTypeHoverText;

      const serviceTitle = data.serviceContact && data.serviceContact.title;
      const csmTitle = data.csmContact && data.csmContact.title;

      scContact.title =
        serviceTitle === "Service Contact" &&
        csmTitle !== "Client Service Manager" &&
        csmTitle
          ? csmTitle
          : serviceTitle;

      this.determineScBusinessHours(data, scContact);
      scContact.showPhone = true;
      this.accountReps.push(scContact);
      this.contactAltText = "Headshot of service contact";
    } else if (
      !this.isServiceContact &&
      data.csmContact &&
      data.csmContact.title &&
      data.csmContact.firstName &&
      data.csmContact.lastName
    ) {
      this.determineCsmBusinessHours(data, csmContact);
      this.accountReps.push(csmContact);
      this.contactAltText = "Headshot of client service manager";
    } else {
      this.getBrContact(data, brContact);
    }
  }
}
